'use client';
/**
 * ./src/app/cart/page.tsx
 *
 * Cart page component accessible from the url /cart
 *
 * @copyright DesignShop, 2024
 * @since 30/04/2024
 */
import Link from 'next/link';

import { Button } from '@/modules/common/components/Button';
import { useAppSelector } from '@/modules/common/hooks/useStore';
import { pluralize } from '@/modules/common/services/utils';

import { ShoppingListFilters } from '../components/ShoppingListFilters';
import { ShoppingListGrid } from '../components/ShoppingListGrid';
import { useShoppingList } from '../context/ShoppingListContext';
import { selectShoppingListTotalItems } from '../state/shoppingListSlice';

export default function ShoppingListPageTemplate() {
  const shoppingListTotalItems = useAppSelector(selectShoppingListTotalItems);
  const pageTitleItems = pluralize(['item', 'items'], shoppingListTotalItems);

  const { isLoading } = useShoppingList();

  if (!isLoading && shoppingListTotalItems === 0) {
    return (
      <div className="app-container py-[6.75rem] text-center lg:pb-[9.625rem] lg:pt-[10.25rem]">
        <h1 className="mb-8 text-[1.75rem] font-bold leading-8">
          {`You haven't saved any items yet`}
        </h1>
        <Link href="/search">
          <Button className="px-6">Explore catalog</Button>
        </Link>
      </div>
    );
  }

  return (
    <>
      <section className="app-container">
        <h1 className="border-b border-gray-75 py-3 text-[1.75rem] font-bold leading-8 md:border-none md:py-5">
          Saves
          {!isLoading && (
            <span className="text-gray-500">
              {' '}
              {shoppingListTotalItems} {pageTitleItems}
            </span>
          )}
        </h1>
      </section>

      <section className="app-container hide-scrollbar overflow-x-auto">
        <ShoppingListFilters />
      </section>

      <section className="app-container">
        <ShoppingListGrid />
      </section>
    </>
  );
}
